import React from 'react'
import { Helmet } from 'react-helmet'
import { company } from '../data/company'

const Seo = ({ title, description, path = '/' }) => {
  const fullTitle = title
    ? `${title} | ${company.shortName}`
    : `${company.shortName} — Product company behind FinQ`
  const desc = description || company.description
  const url = `${company.siteUrl}${path}`
  const image = `${company.siteUrl}/og-image.png`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={company.shortName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}

export default Seo
